import { useTranslation } from "react-i18next";
import Banner from "./components/Banner";
import SolutionsSection from "./components/ourSolution";
import HeroSectionWithImage from "./components/HeroSection";
import AboutSection from "./components/About";
import ScrollContactButton from "../../components/ScrollContactButton";

function Home() {
  const { i18n } = useTranslation();
  return (
    <div>
      <Banner />
      <SolutionsSection />
      <HeroSectionWithImage />
      <AboutSection />
      <ScrollContactButton />
    </div>
  );
}

export default Home;